import { render } from "./hrm-structure-components-modal.vue?vue&type=template&id=5532deca&scoped=true"
import script from "./hrm-structure-components-modal.vue?vue&type=script&lang=js"
export * from "./hrm-structure-components-modal.vue?vue&type=script&lang=js"

import "./hrm-structure-components-modal.vue?vue&type=style&index=0&id=5532deca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5532deca"]])

export default __exports__